module.exports = __webpack_public_path__ + "assets/Retina-BoldItalic.f7ccfd9e5dc5b6b67688cfa094e7c9b4.woff";